/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BillingInvoiceDto = {
    amountInCents: number;
    billingPeriodEnd: number;
    billingPeriodStart: number;
    currency: string;
    dueDate: number;
    emittedDate: number;
    invoiceNumber: string;
    invoicePdf?: string;
    status: BillingInvoiceDto.status;
};

export namespace BillingInvoiceDto {

    export enum status {
        DRAFT = 'DRAFT',
        OPEN = 'OPEN',
        PAID = 'PAID',
        UNCOLLECTIBLE = 'UNCOLLECTIBLE',
        VOID = 'VOID',
    }


}
